import Chart from 'react-apexcharts';
import React, { Component, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { Card, CardContent, Tooltip } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import exportOptions from '../chartExportOptions';
const info = <HelpOutline style={{ fontSize: 15 }}/>;

class UsageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }



  async componentDidMount() {
    const series = {
      users: [],
      count: [],
    }
    const categories = this.props.histogram.map(t => t.data);

    this.props.total.forEach(s => {
      const userData = {name: s.key, data:[]};
      const countData = {name: s.key, data:[]};
      this.props.histogram.forEach(h => {
        const found = h.values.find(d => d.key === s.key)
        userData.data.push(found ? found.users : null);
        countData.data.push(found ? found.count : null);
      })
      series.users.push(userData);
      series.count.push(countData);
    })


    const total = {
      series:[],
      labels:[]
    }
    this.props.total.forEach(s => {
      total.series.push(s.users);
      total.labels.push(s.key);
    })
    
    this.setState({ loading: false, categories, series, total });
  }


  render() {

    if (this.state.loading)
      return null;


    const legend = { 
      itemMargin: {
        horizontal: 0,
        vertical: 0
      },
      formatter: function(seriesName, opts) {
        const maxLength = 20;
        if(seriesName && seriesName.length > maxLength)
          return seriesName.substring(0, maxLength) + "...";
        return seriesName;
      },
    }

    const commonConfig = {
      chart: { animations: { enabled: false }, toolbar: { show: false }, ...exportOptions("Date", "Count") },
      dataLabels: { enabled: false },
      xaxis: { type: "datetime", labels: { show: true }, crosshairs: { width: 1 }, categories: this.state.categories ? this.state.categories : [] },
      legend: { ...legend, position: "right", show: true },
      theme: { mode: 'light', palette: 'palette2', },
      markers: { size: 3, strokeColors: '#fff', strokeWidth: 1, shape: "circle", radius: 2, },
    };

    const pieConfig = {
      chart: { animations: { enabled: false }, type: 'pie', ...exportOptions("Name", "Users") },
      labels: this.state.total ? this.state.total.labels : [],
      responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: 'bottom' } } }],
      colors: ['#32a871', '#608bbd', '#60bd79', '#6071bd', '#e87694', '#7216b8', '#cf3a29'],
      legend
    };

    return (
      <Fragment >
        <Card className="card-box mb-4">
          <CardContent style={{width:"100%"}}>
            <div className=" font-weight-bold font-size-xl text-uppercase" >{this.props.title}</div>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <div className="d-flex align-items-start">
                  <Tooltip title="Here's the unique users over the whole time period.">
                    <div className="font-weight-bold mr-3">Total Unique Users {info}</div>
                  </Tooltip>
                </div>
                <Chart options={pieConfig} series={this.state.total ? this.state.total.series : []} type="pie" height="200"/>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="d-flex align-items-start">
                  <Tooltip title="Here you can see a trendline of unique users over time.">
                    <div className="font-weight-bold mr-3">Unique users {info}</div>
                  </Tooltip>
                </div>
                <Chart options={commonConfig} series={this.state.series.users} type="line" height="200"/>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="d-flex align-items-start">
                  <Tooltip title="Here you can see a trendline of unique records we track over time.">
                    <div className="font-weight-bold mr-3">Usage Records {info}</div>
                  </Tooltip>
                </div>
                <Chart options={commonConfig} series={this.state.series.count} type="line" height="200"/>
              </Grid>
            </Grid>
          </CardContent>
         </Card>
        </Fragment>
    ); // end of return

  } // end of render()

} // end of class

export default UsageComponent
